import { Button, ButtonColors } from '@chiroup/components/Button';
import { stripHtmlTags } from '@chiroup/core/functions/stripHtmlTags';
import { Condition } from '@chiroup/core/types/Condition.type';
import ReactPlayer from 'react-player';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Modal from '../../../../common/Modal';

type Props = {
  setModalOpen: (isOpen: boolean) => void;
  isOpen: boolean;
  data?: {
    [key: string]:
      | {
          video: string;
          descr: string;
          name: string;
        }
      | Condition;
  };
};

const VideoDescriptionModal: React.FC<Props> = ({ data, isOpen }) => {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams() as {
    id: string;
  };

  const closeModal = () => {
    const path = location.pathname;
    const newPath = path.substring(0, path.lastIndexOf('/'));
    navigate(newPath);
  };

  return (
    <Modal isOpen={isOpen} close={closeModal}>
      <div className="text-center mb-6">
        <h3
          className="text-lg leading-6 font-medium text-gray-900 dark:text-dark-gray-100"
          id="modal-headline"
        >
          {data?.[id]?.name}
        </h3>
      </div>
      {data?.[id]?.video?.length && (
        <ReactPlayer
          url={data?.[id]?.video || ''}
          controls
          config={{
            file: {
              attributes: {
                controlsList: 'nodownload',
              },
              forceVideo: true,
              forceHLS: data?.[id]?.video?.includes('.m3u8') && !isSafari,
            },
          }}
          width="100%"
          height="100%"
          className="pb-6 h-full w-full"
          playsinline
        />
      )}

      {data?.[id]?.descr?.length && stripHtmlTags(data?.[id]?.descr)}
      <div className="mt-6 flex justify-end">
        <div>
          <Button
            text="Close"
            onClick={closeModal}
            fullWidth
            color={ButtonColors.plain}
            className="border border-gray-300 dark:border-dark-gray-600"
          />
        </div>
      </div>
    </Modal>
  );
};

export default VideoDescriptionModal;
